<div class="container">

    <form autocomplete="off" [formGroup]="formEdit" (ngSubmit)="save()">
        <div class="row">
            <!-- Menú de preguntas -->
            <div class="col-3 div-fixed div-add-question animated fadeInLeft fast" *ngIf="addQ">
                <div class="row">
                    <div class="p-2"><strong>Añadir pregunta</strong></div>
                    <a class="close" (click)="addQ=!addQ"><i class="fa fa-times"></i></a>
                </div>
                <hr>
                <div *ngIf="qtype.length > 0">
                    <div class="div-svg" *ngFor="let qt of qtype">
                        <a class="a-svg" (click)="addNewQuestion(qt.id)">
                            <img class="svg" src="/assets/img/{{qt.icon}}" alt="{{qt.label}}">
                            {{ capitalize(qt.label) }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-3 animated fadeInLeft fast" *ngIf="addQ">

            </div>
            <!-- Fin Menú de preguntas -->
            <div class="div-edit-survey animated fadeIn fast" [class.col-9]="addQ" [class.col-12]="!addQ">
                <div class="div-edit-board">
                    <div class="text-center mb-3">
                        <div class="row">
                            <div class="col-sm-3">
                                <img class="img-fluid logo-survey" src="/assets/img/logo.png" alt="">
                            </div>
                            <div class="col-sm-9">
                                <textarea class="input-title text-center" type="text"
                                    value="{{survey.title || 'Título de encuesta' }}" formControlName="title" rows="3"
                                    (blur)="save()"></textarea>
                            </div>
                        </div>
                    </div>
                    <!-------------  Questions Group  ------------->


                    <div formArrayName="questions">
                        <div *ngFor="let q of questions.controls; let i = index;" [formGroupName]="i">
                            <!-- <form autocomplete="off" [formGroup]="formArrayQst" (ngSubmit)="saveQ()"> -->
                            <h5 class="order">P{{q.value.order}}</h5>
                            <div class="div-question">
                                <ng-container *ngIf="q.value.idquestiontype == 12">
                                    <div class="div-note">
                                        <input class="input-label-note" *ngIf="q.value.label" formControlName="label"
                                            type="text" value="{{q.value.label}}" (blur)="saveQ(q.value.id)">
                                        <textarea class="input-summary-note" type="text"
                                            value="{{q.value.summary || 'Título de encuesta' }}"
                                            formControlName="summary" rows="5" (blur)="saveQ(q.value.id)"></textarea>
                                        <!-- <div-select class="input-summary-note" *ngIf="q.value.summary"
                                        formControlName="summary" contenteditable="true" innerHTML="{{q.value.summary}}"
                                        (blur)="saveQ(q.value.id)">
                                    </div-select> -->
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="q.value.idquestiontype != 12">
                                    <input class="input-label-q" type="text"
                                        value="{{q.value.label || 'Título de pregunta 2' }}" formControlName="label"
                                        (blur)="saveQ(q.value.id)">
                                    <input class="input-label-q" type="text" value="{{q.value.summary}}"
                                        formControlName="summary" placeholder="Descripción (opcional)"
                                        (blur)="saveQ(q.value.id)">
                                    <div formArrayName="options">
                                        <div *ngFor="let op of options(i).controls; let j = index;" [formGroupName]="j">
                                            <div class="div-option" *ngIf="op.value.idquestion === q.value.id">
                                                <ng-container
                                                    *ngIf="q.value.idquestiontype == 1 || q.value.idquestiontype == 6">
                                                    <i class="fa fa-circle-o"> </i>
                                                    <input class="input-label-opt" type="text"
                                                        value="{{op.value.label || 'Opción' }}" formControlName="label"
                                                        (blur)="saveOp(op.value.id)">
                                                </ng-container>
                                                <ng-container *ngIf="q.value.idquestiontype === 3">
                                                    <i class="fa fa-square-o"> </i>
                                                    <input class="input-label-opt" type="text"
                                                        value="{{op.value.label || 'Opción' }}" formControlName="label"
                                                        (blur)="saveOp(op.value.id)">
                                                </ng-container>

                                            </div>
                                        </div>

                                    </div>
                                    <hr>
                                    <a class="add-option" (click)="addOneOption(q.id)">Añadir opción</a>

                                </ng-container>
                                <div class="div-menu" *ngIf="menuOpp">
                                    <a href="" (click)="guardar()">Guardar</a>
                                </div>
                            </div>
                            <!-- </form> -->
                        </div>
                    </div>
                </div>
                <hr>
            </div>
            <div class="text-center">
                <a class="add-question" (click)="addQ = !addQ">Añadir pregunta</a>
            </div>
            <hr>

        </div>
        <pre>{{formEdit.value | json}}</pre>
    </form>
    <button type="submit" class="btn btn-outline-primary btn-block" (click)="save()">
        Guardar
    </button>
    <!-- </form> -->

</div>